import KTAPI from "../api/index.api";
import { KTLang } from "../lang/lang";
//import { toggleLoader } from "../router/index.routes";


var ObservableSlim = window.obs;//require("../custom/utilities/observable");
var _handler = new window.ev(); 

var KTClasses;

const { io } = window.SocketIO;

var _user = {};

export class User
{
  constructor(info) {    
    this.nickname = info.nickname;
    this.username = info.username || '';
    this.email = info.email || '';
    this.steamid = info.steamid;
    this.communityid = info.communityid;
    this.avatar = info.avatar;
    this.last_login = info.last_login;
    this.countrycode = info.countrycode || '';
    this.country = info.country || '';
    this.city = info.city || '';
    this.roles = info.roles || [];
    this.friends = info.friends || [];
    this.suggestedFriends = info.suggestedFriends || [];
    this.createdAt = info.createdAt;
    this.updatedAt = info.updatedAt;
    
    this.connected = false;
    this.gameInfo = {};
    this.stats = {};
    this.ping = {};

    console.log("Logged and Authed", this);
  }
}


export class AkrosPing {
    constructor() {
        this.socket = null;
        this.connected = false;
        this.serverUrl = 'ws://127.0.0.1:58749';
        this.isAkrosRunning = false;

        // Llama al método para establecer la conexión
        this.connect();
    }

    connect() {
        var self = this;
        self.socket = new WebSocket(self.serverUrl);
        self.socket.timeout = 5000;
        self.socket.addEventListener('error', (event) => {
            // Un error ha ocurrido
            self.connected = false;
            self.isAkrosRunning = false;
            console.error('Error de conexión:', event);
        });

        self.socket.addEventListener('open', () => {
            // La conexión se ha establecido con éxito
            self.connected = true;
            self.isAkrosRunning = true;
            console.log('Conectado a Akros');
        });

        self.socket.addEventListener('close', (event) => {
            if (!event.wasClean) {
                // La conexión se cerró de manera inesperada (por ejemplo, el servidor rechazó la conexión)
                self.connected = false;
                self.isAkrosRunning = false;
                console.info(`Akros is not running: ${event.reason}`);
            } else {
                // La conexión se cerró de manera esperada (puedes manejar esto según tus necesidades)
                self.connected = false;
                console.log('Conexión cerrada de manera esperada');
            }

            // Intenta reconectar después de un breve período de tiempo
            //setTimeout(() => {
            //    self.connect();
            //}, 1000); // Puedes ajustar el tiempo de espera según tus necesidades
        });
    }
}

const axios = window.Axios;
/*export class AkrosPing {
    constructor() {
      this.serverUrl = 'http://127.0.0.1:58749';
      this.pingInterval = 5000; // 5 segundos
      this.process();
      this.isAkrosRunning = false;
      this.state = -1;
    }
  
    process() {
        var self = this;
        _handler.emit('akros', {event: 'checking'});
        const ping = async () => {
            
            const startTime = new Date();
            const xhr = new XMLHttpRequest();

            xhr.onerror = function () {
                
                if (xhr.status === 0 && xhr.statusText === "") {                    
                    //console.log('ECONNREFUSED:', startTime - new Date(), 'ms');                    
                    self.state = 0;
                    if(self.isAkrosRunning)
                    {
                        self.isAkrosRunning = false;
                        _handler.emit('akros', {event: 'close'});
                    }
                    
                    ping();
                }
            };

            xhr.ontimeout = function () {
                //console.log('TIMEOUT:', startTime - new Date(), 'ms');                
                self.state = 1;
                if(!self.isAkrosRunning)
                {
                    self.isAkrosRunning = true;
                    _handler.emit('akros', {event: 'init'});
                }
                
                ping();
            };

            xhr.open('GET', self.serverUrl, true);
            xhr.timeout = 1000 * 2; // 5 segundos
            xhr.send();
        };              
          
        // Iniciar el primer ping y establecer la repetición cada 5 segundos
        ping();
      
    }
  }*/

export class ServerPing
{
    constructor(loc){
        this.socket = null;
        this.connected = false;
        this.serverUrl = `wss://${loc}.pdxplay.org:${loc == 'ny' ? 2096 : 8443}`;
        this.interval = null;
        this.ping = 0;
        this.loc = loc;
        this.listen();
        this.process();

    }

    listen (){
        //console.log("Connecting to", this.serverUrl);        

        this.socket = io(this.serverUrl, {
            reconnection: true,
            reconnectionDelay: 1000,
            reconnectionDelayMax: 5000,
            reconnectionAttempts: Infinity,
            query: {none: ''}
        });
        
    }

    process (){   
        var self = this;
        this.socket.on('connect', function () {
            //console.log('Connected PingServer to', self.loc);
            self.connected = true;

            self.socket.emit('latency', Date.now(), function(startTime) {
                self.ping = Date.now() - startTime;
                $(`[data-location=${self.loc}]`).attr("data-ping", self.ping);
                $(`[data-showping=${self.loc}]`).text(self.ping);
                $(`[data-iconping=${self.loc}]`).attr('class', function(i, c){
                    return c.replace(/(^|\s)text-\S+/g, '');
                }).addClass(getPingColor(self.ping));
                
                
                if(!_user.hasOwnProperty('ping')) _user.ping = {};                    
                _user.ping[self.loc] = self.ping;
                //console.log(self.loc,self.ping, "ms");
                _handler.emit('ping', {loc: self.loc, ping: self.ping});
            });

            self.interval = setInterval(() => {
                self.socket.emit('latency', Date.now(), function(startTime) {
                    self.ping = Date.now() - startTime;
                    $(`[data-location=${self.loc}]`).attr("data-ping", self.ping);
                    $(`[data-showping=${self.loc}]`).text(self.ping);
                    $(`[data-iconping=${self.loc}]`).attr('class', function(i, c){
                        return c.replace(/(^|\s)text-\S+/g, '');
                    }).addClass(getPingColor(self.ping));
                    
                    if(!_user.hasOwnProperty('ping')) _user.ping = {};                    
                    _user.ping[self.loc] = self.ping;
                    //console.log(self.loc,self.ping, "ms");
                    _handler.emit('ping', {loc: self.loc, ping: self.ping});
                });
            }, 25000);
        });
        this.socket.on('disconnect', (reason) => {
            self.connected = false;
            clearInterval(self.interval);
            self.interval = null;
            
            //console.log('Disconnected PingServer from', self.loc, 'Reason:',reason);
        });
    }
    
}

export class PopoverProfileManager {
    constructor() {
        this.init();
        this.profileHtml = {},
        this.hideTimeout = null
    }

    init() {
        $(document).on('mouseenter', '.popover-profile', (event) => {
            this.showPopover(event.currentTarget);
        });

        $(document).on('mouseleave', '.popover-profile, .popover', (event) => {
            this.hideTimeout = setTimeout(() => {
                this.hidePopover(event.relatedTarget || event.toElement);
            }, 200);
        });

        $(document).on('mouseenter', '.popover, .popover-profile', () => {            
            clearTimeout(this.hideTimeout);
        });

        $(document).on('click', (event) => {
            this.hidePopoverOnClick(event.target);
        });

        $(document).on('show.bs.popover', '.popover-profile', (event) => {
            
            
        });

        $(document).on('shown.bs.popover', '.popover-profile', async (event) => {
                        
            let popid = $(event.currentTarget).attr('aria-describedby');
            toggleLoader(`#${popid} .popover-body`);

            const steamid = $(event.currentTarget).data('steamid');

            let popoverContent = '<span></span>';

            if (this.profileHtml[steamid]) 
            {
                popoverContent = this.profileHtml[steamid];                
            }
            else
            {
                try {
                    let stats = await KTAPI.getPlayerStats({steamid});
                    if(stats.message == 'error') return;
                    this.profileHtml[steamid] = this.createPopoverContent(stats.res);
                    popoverContent = this.profileHtml[steamid];
                } catch (error) {
                    console.error(error);
                    return;
                }
            }

            popoverContent = $(popoverContent);
            popoverContent.localize();
            $(`#${popid} .popover-body`).html(popoverContent);
            KTApp.initCountUp();
            KTApp.initCountUpTabs();
            window.KTRouter.router.updatePageLinks();

        });

        $(document).on('hide.bs.popover', '.popover-profile', (event) => {

        });

        $(document).on('hidden.bs.popover', '.popover-profile', (event) => {

        });
    }

    async showPopover(element) {
         
        $('.popover-profile').each(function(index) {
            var element = $('.popover-profile').eq(index);
            if (element.attr('aria-describedby') && element.attr('aria-describedby').includes('popover')) {
                element.popover('dispose');
            }
        });
        const steamid = $(element).data('steamid');
        let popoverContent = '<span></span>';

        /*if (this.profileHtml[steamid]) 
        {
            popoverContent = this.profileHtml[steamid];
            popoverContent = $(popoverContent);
            popoverContent.localize();
        }
        else
        {
            try {
                let stats = await KTAPI.getPlayerStats({steamid});
                if(stats.message == 'error') return;
                this.profileHtml[steamid] = this.createPopoverContent(stats.res);
                popoverContent = this.profileHtml[steamid];
            } catch (error) {
                console.error(error);
                return;
            }
        }*/        

        $(element).popover({
            container: 'body',
            html: true,
            //content: popoverContent[0].outerHTML,
            content: popoverContent,
            trigger: 'manual',
            boundary: 'viewport',
            placement: 'auto',
            template: '<div class="popover popover-prof" role="tooltip"><div class="popover-arrow"></div><div class="popover-body"></div></div>',
            sanitize: false,
        })
        .on('show.bs.popover', (e) => {
            
        })
        .on('shown.bs.popover', () => {
            
        }).
        on('hide.bs.popover', () => {
            
        })
        .on('hidden.bs.popover', () => {
            
        })
        .popover('show');
    }

    hidePopover(target) {
        const isPopoverProfile = $(target).hasClass('popover-profile');

        if (!isPopoverProfile) {
            $('.popover').popover('dispose');
        }
    }

    hidePopoverOnClick(target) {
        const isPopoverProfile = $(target).hasClass('popover-profile');

        if (!isPopoverProfile) {
            $('.popover').popover('dispose');
        }
    }

    createPopoverContent(data) {
        let html = /* html */`
        <div class="card card-flush w-100 p-0 m-0 bg-transparent shadow-0">
            <!--<div class="card-header">-->
                <!--begin::Heading-->
                <!--<div class="card-title">
                    <h4 class="d-flex align-items-center"><i class="fal fa-analytics text-primary align-self-center me-3"></i><span data-i18n="user.overview_mainstats">Main Stats</span></h4>
                </div>-->
                <!--end::Heading-->
        
                <!--begin::Toolbar-->
                <!--<div class="card-toolbar">                        
                    <a data-navigo href="#" class="btn btn-sm btn-light-primary my-1 profile-quicklink" tab="stats" data-i18n="user.nav_viewall">
                        View All
                    </a>
                </div>-->
                <!--end::Toolbar-->
            <!--</div>-->
            <!--begin::Body-->
            <div class="d-flex flex-column w-100">
                <div class="d-flex flex-row-fluid justify-content-between w-100">
                    <div class="d-flex flex-row align-items-center gap-3">
                        <div class="symbol symbol-40px">
                            <img src="${data.profile.avatar}" alt="image">
                        </div>
                        <div class="d-flex flex-column">
                            <div class="fw-bolder fs-4"><a data-navigo class="text-dark" href="user/${data.profile.communityid}">${data.profile.nickname}</a></div>
                            <div class="d-flex flex-row-fluid gap-2">
                                <div><a data-navigo href="user/${data.profile.communityid}"><img class="img-fluid" src="assets/media/flags/${data.profile.countrycode !== '' ? data.profile.countrycode.toLowerCase() : ''}.gif"/></a></div>
                            </div>
                        </div>
                    </div>
                    <div class="symbol symbol-45px">
                        <img class="overview-rank-img" src="assets/media/ranks/rank_0.png">
                    </div>

                </div>
            </div>

            <div class="d-flex flex-column w-100 mt-4">
                <div class="d-flex flex-row justify-content-between">
                    <span class="text-dark me-2 fw-bold pb-3">
                        <span data-i18n="user.level">Level</span> <span class="overview-rank-level">0</span>
                    </span>

                    <div>
                    <span class="text-dark fw-bold pb-3 fs-7">
                        <span class="overview-rating">-</span>
                    </span>
                    /
                    <span class="text-gray-700 fw-bold pb-3 fs-8 overview-rating-next">
                        800
                    </span>
                    </div>
                </div>

                <div class="progress h-5px w-100 bg-primary bg-opacity-50">
                    <div class="progress-bar bg-primary overview-progress" role="progressbar" aria-valuenow="89" aria-valuemin="0" aria-valuemax="100"></div>
                </div>
            </div>

            <div class="separator separator-dashed my-5"></div>

            <div class="d-flex flex-row justify-content-between">
                <div class="d-flex flex-column pe-6 gap-6 justify-content-center">
                    <div class="d-flex flex-column gap-0 justify-content-center">
                        <h5 class="mb-0 text-center overview-matches">0</h5>
                        <span class="text-gray-600 fs-8 text-uppercase text-center" data-i18n="user.nav_matches">Matches</span>
                    </div>                                                        
                </div>

                <div class="d-flex flex-column gap-3 flex-grow-1 flex-shrink-1 mw-325px">
                    <div class="w-100">
                        <div class="d-flex flex-column w-100">
                            <div class="d-flex justify-content-between px-1 mb-1">
                                <div class="d-flex gap-2">
                                    <span class="align-self-end text-uppercase fs-8 text-gray-600" data-i18n="user.won">Won</span>
                                    <h3 class="mb-0 align-self-end text-white fs-7 overview-matches-won">0</h3>
                                </div>

                                <div class="d-flex gap-2">
                                    <h3 class="mb-0 align-self-end text-white fs-7 overview-matches-lose">0</h3>
                                    <span class="align-self-end text-uppercase text-gray-600 fs-8" data-i18n="user.lose">Lose</span>                                                                        
                                </div>
                            </div>

                            <div class="p-1 d-flex flex-row gap-0 rounded bg-light w-100">
                                <div class="progress h-5px overview-progress-won rounded-end-0" data-toggle="tooltip" title="" style="width:50%">
                                    <div class="progress-bar bg-success w-100" role="progressbar"></div>
                                </div>
                                <div class="progress h-5px overview-progress-lose rounded-start-0" data-toggle="tooltip" title="" style="width:50%">
                                    <div class="progress-bar bg-danger w-100" role="progressbar"></div>
                                </div>
                            </div>

                            <div class="d-flex justify-content-between px-1 mt-2">
                                <div class="d-flex gap-2">
                                    <h6 class="mb-0 align-self-end text-white overview-matches-won-percent">50%</h6>
                                </div>

                                <div class="d-flex gap-2">
                                    <h6 class="mb-0 align-self-end text-white overview-matches-lose-percent">50%</h6>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>

            <div class="separator separator-dashed my-5"></div>

            
            <div class="card-body p-0">

                <!--begin::Stats-->
                <div class="row">
                    <!--begin::Col-->
                    <div class="col pe-1">
                        <div class="card border border-primary flex-center px-2 py-1 bg-light-primary">
                            <span class="fs-lg-6 fw-bolder d-flex justify-content-center">
                                <span class="overview-rating text-dark" data-kt-countup="true" data-kt-countup-value="0" data-kt-countup-separator="">0</span>
                            </span>
                            <span class="fs-8 fw-smibold text-gray-800 px-2" data-toggle="tooltip" title="Glicko earned" data-i18n="[title]stats.trating;[data-bs-original-title]stats.trating">RATING</span>
                        </div>
                    </div>
                    <!--end::Col-->

                    <!--begin::Col-->
                    <div class="col px-1">
                        <div class="card card-dashed flex-center px-2 py-1" style="background-color:#1b1b1b">
                            <span class="fs-lg-6 fw-bolder d-flex justify-content-center">
                                <span class="overview-kdr" data-kt-countup="true" data-kt-countup-decimal-places="2" data-kt-countup-value="0.0">0</span>
                            </span>
                            <span class="fs-8 fw-semibold text-gray-600 px-2" data-toggle="tooltip" title="Kill/Death Ratio" data-i18n="[title]stats.tkdr;[data-bs-original-title]stats.tkdr">KDR</span>
                        </div>
                    </div>
                    <!--end::Col-->

                    
                    <!--begin::Col-->
                    <div class="col px-1">
                        <div class="card card-dashed flex-center px-2 py-1" style="background-color:#1b1b1b">
                            <span class="fs-lg-6 fw-bolder d-flex justify-content-center">
                                <span class="overview-kpr" data-kt-countup="true" data-kt-countup-decimal-places="2" data-kt-countup-value="0.0">0</span>
                            </span>
                            <span class="fs-8 fw-semibold text-gray-600 px-2" data-toggle="tooltip" title="Kills per Round" data-i18n="[title]stats.tkpr;[data-bs-original-title]stats.tkpr">KPR</span>
                        </div>
                    </div>
                    <!--end::Col-->  

                    <!--begin::Col-->
                    <div class="col px-1">
                        <div class="card card-dashed flex-center px-2 py-1" style="background-color:#1b1b1b">
                            <span class="fs-lg-6 fw-bolder d-flex justify-content-center">
                                <span class="overview-adr" data-kt-countup="true" data-kt-countup-decimal-places="2" data-kt-countup-value="0.00">0.00</span>
                            </span>
                            <span class="fs-8 fw-semibold text-gray-600 px-2" data-toggle="tooltip" title="Average Damage per Round" data-i18n="[title]stats.tadr;[data-bs-original-title]stats.tadr">ADR</span>
                        </div>
                    </div>
                    <!--end::Col-->
                    
                    <!--begin::Col-->
                    <div class="col ps-1">
                        <div class="card card-dashed flex-center px-2 py-1" style="background-color:#1b1b1b">
                            <span class="fs-lg-6 fw-bolder d-flex justify-content-center">
                                <span class="overview-hsp" data-kt-countup="true" data-kt-countup-decimal-places="2" data-kt-countup-value="0.00" data-kt-countup-suffix="%">0</span>
                            </span>
                            <span class="fs-8 fw-semibold text-gray-600 px-2" data-toggle="tooltip" title="Headshots Percentage" data-i18n="[title]stats.thsp;[data-bs-original-title]stats.thsp">HSP</span>
                        </div>
                    </div>
                    <!--end::Col-->                                
                </div>
                <!--end::Stats-->
                
            </div>
        </div>
        `;
        

        html = $(html);
        html.localize();

        
        
        html.find(".overview-rating").text(data.rating);

        html.find(".overview-rating").attr("data-kt-countup-value", data.rating);
        html.find(".overview-kdr").attr("data-kt-countup-value", (data.kills/(data.deaths == 0 ? 1 : data.deaths)).toFixed(2));
        html.find(".overview-kpr").attr("data-kt-countup-value", (data.kills/(data.rounds == 0 ? 1 : data.rounds)).toFixed(2));
        html.find(".overview-adr").attr("data-kt-countup-value", (data.damage/(data.rounds == 0 ? 1 : data.rounds)).toFixed(2));
        html.find(".overview-hsp").attr("data-kt-countup-value", (data.hs*100/(data.deaths == 0 ? 1 : data.deaths)).toFixed(2));
        
        let rnk = getEloLevel(data.rating, data.rd);
        html.find(".overview-rank-img").attr("src", `assets/media/ranks/rank_${rnk.level}.png`);
        html.find(".overview-rank-level").text(rnk.level);
        html.find(".overview-rating-next").text(rnk.next);

        //html.find(".overview-progress").css("width", `${(data.rating - rnk.prev)*100/(rnk.next - rnk.prev)}%`);
        html.find(".overview-progress").addClass(`wp-${parseInt((data.rating - rnk.prev)*100/(rnk.next - rnk.prev))}`);
        html.find(".overview-progress").attr("aria-valuenow", (data.rating - rnk.prev)*100/(rnk.next - rnk.prev));

        let m = data.matches_win + data.matches_lose;
        html.find(".overview-matches").text(data.matches);
        html.find(".overview-matches-won").text(data.matches_win);
        html.find(".overview-matches-lose").text(data.matches_lose);
        //html.find(".overview-progress-won").css("width", `${(data.matches_win * 100 / (m == 0 ? 1 : m)).toFixed(0)}%`);
        //html.find(".overview-progress-lose").css("width", `${(data.matches_lose * 100 / (m == 0 ? 1 : m)).toFixed(0)}%`);
        html.find(".overview-progress-won").addClass(`wp-${parseInt((data.matches_win * 100 / (m == 0 ? 1 : m)).toFixed(0))}`);
        html.find(".overview-progress-lose").addClass(`wp-${parseInt((data.matches_lose * 100 / (m == 0 ? 1 : m)).toFixed(0))}`);
        html.find(".overview-matches-won-percent").text((data.matches_win * 100 / (m == 0 ? 1 : m)).toFixed(0)+"%");
        html.find(".overview-matches-lose-percent").text((data.matches_lose * 100 / (m == 0 ? 1 : m)).toFixed(0)+"%");

        setTimeout(() => {
            KTApp.initCountUp();
            KTApp.initCountUpTabs();
        }
        , 1000);

        return html;

    }
}

export class TimeAgoUpdater {
    constructor(selector) {
        this.selector = selector;
        this.timers = {}; // Almacena los identificadores de intervalo para cada elemento
        this.updateTimeAgo(); // Actualiza el tiempo transcurrido inicialmente
        this.startInterval(); // Inicia el intervalo para actualizar el tiempo transcurrido
    }

    updateTimeAgo() {
        const _this = this;
        $(this.selector).each(function(index, element) {
            const $element = $(element);
            const timestampAttr = $element.attr('moment-timestamp');
            if (!timestampAttr) return; // No se encontró el atributo 'moment-timestamp'

            const timestamp = _this.parseTimestamp(timestampAttr);
            if (!timestamp.isValid()) return; // El timestamp no es válido

            //const timeAgo = timestamp.fromNow(); // Formatea el tiempo transcurrido
            const timeAgo = timestamp.locale(KTLang.getLang()).fromNow(); // Formatea el tiempo transcurrido
            $element.text(timeAgo); // Actualiza el contenido del elemento HTML
            //agrega el atributo title con la fecha completa para mostrar en el tooltip al pasar el mouse
            //$element.attr('title', timestamp.locale(KTLang.getLang()).format('LLLL'));
            if(!$element.attr('title')) $element.attr('title', timestamp.locale(KTLang.getLang()).format('LLLL'));

            // Registra un temporizador para este elemento si aún no existe
            if (!_this.timers[$element]) {
                _this.timers[$element] = setInterval(function() {
                    _this.updateTimeAgoElement($element); // Actualiza el tiempo transcurrido para este elemento
                }, 60000); // 60000 milisegundos = 1 minuto
            }
        });
    }

    updateTimeAgoElement($element) {
        const timestampAttr = $element.attr('moment-timestamp');
        const timestamp = this.parseTimestamp(timestampAttr);
        if (!timestamp.isValid()) return; // El timestamp no es válido

        //const timeAgo = timestamp.fromNow(); // Formatea el tiempo transcurrido
        const timeAgo = timestamp.locale(KTLang.getLang()).fromNow(); // Formatea el tiempo transcurrido
        $element.text(timeAgo); // Actualiza el contenido del elemento HTML
    }

    parseTimestamp(timestampAttr) {
        // Intenta convertir el timestamp a un objeto Moment.js
        const formats = [
            moment.ISO_8601, // Intenta ISO 8601
            'YYYY-MM-DDTHH:mm:ss', // Añade aquí otros formatos si es necesario
            'X' // Formato UNIX timestamp
        ];
        
        for (let format of formats) {
            const timestamp = moment(timestampAttr, format, true);
            if (timestamp.isValid()) {
                return timestamp;
            }
        }
    
        // Si ninguno de los formatos es válido, retorna un momento "no válido"
        return moment.invalid();
    }

    startInterval() {
        const _this = this;
        this.intervalId = setInterval(function() {
            _this.updateTimeAgo(); // Actualiza el tiempo transcurrido para todos los elementos seleccionados
            _this.checkElementExistence(); // Verifica si los elementos aún existen en el DOM
        }, 60000); // 60000 milisegundos = 1 minuto
    }

    checkElementExistence() {
        const _this = this;
        $(this.selector).each(function(index, element) {
            const $element = $(element);
            if ($element.length === 0) {
                _this.stopIntervalForElement($element); // Detiene el intervalo y destruye el temporizador para este elemento
            }
        });
    }

    stopIntervalForElement($element) {
        clearInterval(this.timers[$element]); // Detiene el intervalo asociado a este elemento
        delete this.timers[$element]; // Elimina el temporizador de la lista de temporizadores
    }
}

// crea una clase robusta y escalable para manejar las notificaciones toastr dinamicamente con opciones personalizadas
export class ToastrManager {
    constructor() {
        this.options = {
            "closeButton": false,
            "debug": false,
            "newestOnTop": true,
            "progressBar": false,
            "positionClass": "toastr-top-center",
            "preventDuplicates": false,
            "onclick": null,
            "showDuration": "300",
            "hideDuration": "1000",
            "timeOut": "5000",
            "extendedTimeOut": "1000",
            "showEasing": "linear",
            "hideEasing": "linear",
            "showMethod": "fadeIn",
            "hideMethod": "fadeOut"
        };
    }

    showSuccess(message) {
        toastr.success(message, "", this.options);
    }

    showError(message) {
        toastr.error(message, "", this.options);
    }

    showWarning(message) {
        toastr.warning(message, "", this.options);
    }

    showInfo(message) {
        toastr.info(message, "", this.options);
    }
}

export const Toasted = new ToastrManager();

export class ClipboardManager {
    constructor(selector, options = {}) {
        this.selector = selector;

        if(Object.keys(options).length > 0)
            this.clipboard = new ClipboardJS(selector, options);
        else
            this.clipboard = new ClipboardJS(selector);
                
        this.clipboard.on('success', function(e) {
            //console.log('Texto copiado:', e.text);
            // Aquí puedes agregar tu lógica adicional, como mostrar un mensaje de éxito
            // extrae el atributo i18n-label del elemento que disparó el evento
            const i18nLabel = $(e.trigger).attr('i18n-label');

            const $temp = $(`<div data-i18n=${i18nLabel}>`);
            $temp.localize();
            const sanitizedHTML = $temp.text();
            Toasted.showSuccess(sanitizedHTML);
            e.clearSelection();
        });

        this.clipboard.on('error', function(e) {
            //console.error('Error al copiar:', e.trigger);
            // Aquí puedes agregar tu lógica adicional, como mostrar un mensaje de error
            const $temp = $(`<div data-i18n="example.copied_error">`);
            $temp.localize();
            const sanitizedHTML = $temp.text();
            Toasted.showError(sanitizedHTML);
        });
    }    

    destroy() {
        // Destruye el objeto ClipboardJS y libera los recursos
        this.clipboard.destroy();
    }
}

export const Clip = new ClipboardManager('.clip');


const getPingColor = (ping) => {
    if(ping <= 50) return "text-success";
    if(ping <= 100) return "text-zyellow";
    if(ping <= 150) return "text-zorange";
    if(ping <= 200) return "text-danger";
    if(ping <= 999) return "text-gray-600";
    return "text-muted";
};

const getEloLevel = (rate, rd) => {
    if(rd == 100) return {level: 0, prev: 0, next:800};
    if(rate >= 0 && rate < 801)
    {
        return {level: 1, prev: 0, next:800};
    }
    if(rate > 800 && rate < 951)
    {
        return {level: 2, prev: 800, next:950};
    }
    if(rate > 950 && rate < 1101)
    {
        return {level: 3, prev: 950, next:1100};
    }
    if(rate > 1100 && rate < 1251)
    {
        return {level: 4, prev: 1100, next:1250};
    }
    if(rate > 1250 && rate < 1401)
    {
        return {level: 5, prev: 1250, next:1400};
    }
    if(rate > 1400 && rate < 1551)
    {
        return {level: 6, prev: 1400, next:1550};
    }
    if(rate > 1550 && rate < 1701)
    {
        return {level: 7, prev: 1550, next:1700};
    }
    if(rate > 1700 && rate < 1851)
    {
        return {level: 8, prev: 1700, next:1850};
    }
    if(rate > 1850 && rate < 2001)
    {
        return {level: 9, prev: 1850, next:2000};
    }
    if(rate > 2000)
    {
        return {level: 10, prev: 2000, next:2000};
    }
};

// Función para mostrar u ocultar el loader con promesas manuales
const toggleLoader = (targetSelector, displayTime, loadingProgress) => {
    return new Promise(resolve => {
      var loaderContainer = $(targetSelector).find('.loader');
  
      if (loaderContainer.length === 0) {
        var loader = $("<div class='loader'></div>");
        //var loaderA = $(`<div class='loader-a' style="background: url('assets/media/logos/loader-a.png') no-repeat;"></div>`);
        //var loaderB = $(`<div class='loader-b' style="background: url('assets/media/logos/loader-b.png') no-repeat 0 100%;"></div>`);
        var loaderA = $(`<div class='loader-a' style="background: url('assets/media/logos/pdxplay_render.png') no-repeat;opacity:0.5;"></div>`);
        var loaderB = $(`<div class='loader-b' style="background: url('assets/media/logos/pdxplay_render.png') no-repeat 0 100%;"></div>`);
        //var loadingText = $('<div class="loading-text" data-i18n="example.loadng"></div>');
        var loadingText = $('');

        loadingText.localize();
  
        loaderA.append(loaderB);
        loader.append(loaderA);
        loader.append(loadingText);
        $(targetSelector).append(loader);
  
        // Si no hay animación, resuelve la promesa inmediatamente
        if (!(displayTime || loadingProgress)) {
          resolve();
          return;
        }
  
        loader.fadeIn(500, function () {
          if (loadingProgress !== undefined) {
            var animationDuration = (loadingProgress >= 0) ? loadingProgress : 2;
            loaderB.css('animation-duration', animationDuration + 's');
          }
  
          if (displayTime !== undefined && displayTime !== 0) {
            setTimeout(function () {
              loader.fadeOut(500, function () {
                loader.remove();
              });
            }, displayTime);
          }
          // Resuelve la promesa después de mostrar el loader
          resolve();
        });
      } else {
        // Si no hay animación, resuelve la promesa inmediatamente
        if (!(displayTime || loadingProgress)) {
          loaderContainer.remove();
          resolve();
          return;
        }
  
        loaderContainer.fadeOut(500, function () {
          loaderContainer.remove();
          // Resuelve la promesa después de ocultar el loader
          resolve();
        });
      }
    });
  };


const storage = {
    
        set: function(key, value) {
            if (!key || !value) {return;}
    
            if (typeof value === "object") {
                value = JSON.stringify(value);
            }
    
            localStorage.setItem(key, value);
        },
        get: function(key) {
            var value = localStorage.getItem(key);
    
            if (!value) {return null;}
    
            // intenta analizar como un objeto JSON
            try {
                value = JSON.parse(value);
            } catch (e) {
                // si el análisis falla, devuelve el valor original
            }
    
            return value;
        }
    };

export class CustomDialog {
    constructor(options) {
        this.title = options.title || 'Error';
        this.content = options.content || '';
        this.buttons = options.buttons || [];
        this.onShow = options.onShow || null;
        this.onHide = options.onHide || null;
        this.autoHide = options.autoHide || false;
        this.autoHideDelay = options.autoHideDelay || 0;
        this.onAutoHide = options.onAutoHide || null;
        this.disableCloseButton = options.disableCloseButton || false;
        this.noBackdrop = options.noBackdrop || false;
        this.verticallyCentered = options.verticallyCentered || false;
        this.scrollable = options.scrollable || false;
        this.dialogClasses = options.dialogClasses || '';
        this.bodyClasses = options.bodyClasses || '';
        this.headerClasses = options.headerClasses || 'bg-gray-100';
        this.footerClass = options.footerClass || '';
        this.init();
        this.getDialogId = () => this.dialogId;
    }

    init() {
        this.dialogId = 'custom-dialog-' + new Date().getTime();
        const closeButtonHTML = this.disableCloseButton ? '' : `
            <button type="button" class="btn-close btn btn-sm btn-icon btn-active-light-primary" data-bs-dismiss="modal" aria-label="Close" style="background: none !important;opacity: 1.0 !important;"><i class="bi bi-x-lg fs-6"></i></button>`;
        const dialogClasses = [
            'modal-dialog',
            this.verticallyCentered ? 'modal-dialog-centered' : '',
            this.scrollable ? 'modal-dialog-scrollable' : '',
            this.dialogClasses ? this.dialogClasses : ''
        ].join(' ');

        const dialogHTML = `
            <div class="modal fade custom-dialog" id="${this.dialogId}" tabindex="-1" aria-labelledby="${this.dialogId}-label" aria-hidden="true">
                <div class="${dialogClasses}">
                    <div class="modal-content">
                        <div class="modal-header py-4 justify-content-center border-0 ${this.headerClasses}">
                            <h5 class="modal-title fw-bolder text-gray-700" id="${this.dialogId}-label">${this.title}</h5>
                            ${closeButtonHTML}
                        </div>
                        <div class="modal-body py-6 text-gray-700 ${this.bodyClasses}">
                            ${this.content}
                        </div>
                        <div class="modal-footer border-0 py-4 ${this.footerClass}">
                            ${this.buttons.map((btn, index) => `
                                <button type="button" class="btn btn-sm ${btn.class}" id="${this.dialogId}-btn-${index}" ${btn.attributes}>${btn.text}</button>
                            `).join('')}
                        </div>
                    </div>
                </div>
            </div>
        `;

        $('body').append(dialogHTML);

        this.bindEvents();
    }

    bindEvents() {
        this.buttons.forEach((btn, index) => {
            $(`#${this.dialogId}-btn-${index}`).on('click', () => {
                if (typeof btn.callback === 'function') {
                    btn.callback();
                }
                if (btn.dismiss) {
                    this.hide();
                }
            });
        });

        $(`#${this.dialogId}`).on('shown.bs.modal', () => {
            if (typeof this.onShow === 'function') {
                this.onShow();
            }
            if (this.autoHide) {
                this.autoHideTimeout = setTimeout(() => {
                    if (typeof this.onAutoHide === 'function') {
                        this.onAutoHide();
                    }
                    this.hide();
                }, this.autoHideDelay);
            }
        });

        $(`#${this.dialogId}`).on('hidden.bs.modal', () => {
            if (typeof this.onHide === 'function') {
                this.onHide();
            }
            $(`#${this.dialogId}`).remove();
            if (this.autoHideTimeout) {
                clearTimeout(this.autoHideTimeout);
            }
        });

        const modalOptions = {
            backdrop: this.noBackdrop ? false : (this.disableCloseButton ? 'static' : true),
            keyboard: this.disableCloseButton ? false : true
        };

        $(`#${this.dialogId}`).modal(modalOptions);
    }

    show() {
        $(`#${this.dialogId}`).modal('show');
    }

    hide() {
        $(`#${this.dialogId}`).modal('hide');
    }

    cancelAutoHide() {
        if (this.autoHideTimeout) {
            clearTimeout(this.autoHideTimeout);
        }
    }
}

export class Countdown {
    constructor({ seconds = 0, minutes = 0, hours = 0, displayElement, onTick = null, onComplete = null }) {
        if (!displayElement) {
            throw new Error("Se requiere un elemento de visualización.");
        }

        this.totalSeconds = seconds + minutes * 60 + hours * 3600;
        this.displayElements = $(displayElement); // Selecciona todos los elementos con la clase
        this.onTick = onTick;
        this.onComplete = onComplete;
        this.timer = null;
        this.remainingSeconds = this.totalSeconds;

        this.validateInputs();
        this.updateDisplay();
    }

    validateInputs() {
        if (typeof this.totalSeconds !== 'number' || this.totalSeconds < 0) {
            throw new Error("El tiempo debe ser un número no negativo.");
        }

        if (typeof this.onTick !== 'function' && this.onTick !== null) {
            throw new Error("onTick debe ser una función o null.");
        }

        if (typeof this.onComplete !== 'function' && this.onComplete !== null) {
            throw new Error("onComplete debe ser una función o null.");
        }
    }

    padNumber(number) {
        return String(number).padStart(2, '0');
    }

    calculateTime() {
        const hours = Math.floor(this.remainingSeconds / 3600);
        const minutes = Math.floor((this.remainingSeconds % 3600) / 60);
        const seconds = this.remainingSeconds % 60;

        return { hours, minutes, seconds };
    }

    updateDisplay() {
        //console.log(this.remainingSeconds);
        const { hours, minutes, seconds } = this.calculateTime();
        const formattedTime = hours > 0 
            ? `${this.padNumber(hours)}:${this.padNumber(minutes)}:${this.padNumber(seconds)}`
            : `${this.padNumber(minutes)}:${this.padNumber(seconds)}`;

        // Actualiza el texto de todos los elementos con la clase
        this.displayElements.text(formattedTime);
    }

    start() {
        if (this.timer !== null) {
            return; // Ya se está ejecutando
        }

        this.timer = setInterval(() => {
            if (this.remainingSeconds <= 0) {
                this.stop();
                if (this.onComplete) {
                    this.onComplete();
                }
            } else {
                this.remainingSeconds--;
                //console.log(this.remainingSeconds);
                this.updateDisplay();
                if (this.onTick) {
                    this.onTick(this.calculateTime());
                }
            }
        }, 1000);
    }

    pause() {
        clearInterval(this.timer);
        this.timer = null;
    }

    stop() {
        this.pause();
        this.remainingSeconds = this.totalSeconds;
        this.updateDisplay();
    }

    reset() {
        this.stop();
        this.start();
    }

    setSeconds(seconds) {
        this.totalSeconds = seconds;
        this.remainingSeconds = seconds;
        this.stop();
        this.start();

    }
}

export class CountUp {
    constructor({ startSeconds = 0, maxSeconds = null, displayElement, onTick = null, onComplete = null }) {
        if (!displayElement) {
            throw new Error("Se requiere un elemento de visualización.");
        }

        this.displayElements = $(displayElement); // Selecciona todos los elementos con la clase
        this.onTick = onTick;
        this.onComplete = onComplete;
        this.timer = null;
        this.elapsedSeconds = startSeconds; // Comienza desde startSeconds
        this.maxSeconds = maxSeconds;

        this.validateInputs();
        this.updateDisplay();
    }

    validateInputs() {
        if (this.maxSeconds !== null && (typeof this.maxSeconds !== 'number' || this.maxSeconds < 0)) {
            throw new Error("maxSeconds debe ser un número no negativo o null.");
        }

        if (typeof this.elapsedSeconds !== 'number' || this.elapsedSeconds < 0) {
            throw new Error("startSeconds debe ser un número no negativo.");
        }

        if (typeof this.onTick !== 'function' && this.onTick !== null) {
            throw new Error("onTick debe ser una función o null.");
        }

        if (typeof this.onComplete !== 'function' && this.onComplete !== null) {
            throw new Error("onComplete debe ser una función o null.");
        }
    }

    padNumber(number) {
        return String(number).padStart(2, '0');
    }

    calculateTime() {
        const hours = Math.floor(this.elapsedSeconds / 3600);
        const minutes = Math.floor((this.elapsedSeconds % 3600) / 60);
        const seconds = this.elapsedSeconds % 60;

        return { hours, minutes, seconds };
    }

    updateDisplay() {
        const { hours, minutes, seconds } = this.calculateTime();
        const formattedTime = hours > 0 
            ? `${this.padNumber(hours)}:${this.padNumber(minutes)}:${this.padNumber(seconds)}`
            : `${this.padNumber(minutes)}:${this.padNumber(seconds)}`;

        // Actualiza el texto de todos los elementos con la clase
        this.displayElements.text(formattedTime);
    }

    start() {
        if (this.timer !== null) {
            return; // Ya se está ejecutando
        }

        this.timer = setInterval(() => {
            this.elapsedSeconds++;
            this.updateDisplay();
            if (this.onTick) {
                this.onTick(this.calculateTime());
            }

            if (this.maxSeconds !== null && this.elapsedSeconds >= this.maxSeconds) {
                this.stop();
                if (this.onComplete) {
                    this.onComplete();
                }
            }
        }, 1000);
    }

    pause() {
        clearInterval(this.timer);
        this.timer = null;
    }

    stop() {
        this.pause();
        this.elapsedSeconds = 0;
        this.updateDisplay();
    }

    reset() {
        this.stop();
        this.start();
    }
}

class SoundManager {
    constructor() {
        this.sounds = {};
    }

    /**
     * Adds a sound to the sound manager with a default volume of 0.5.
     * @param {string} name - The unique name to reference the sound.
     * @param {string} filePath - The path to the sound file.
     */
    addSound(name, filePath) {
        if (!this.sounds[name]) {
            const audio = new Audio(filePath);
            audio.preload = "auto";  // Preload the audio for faster play
            audio.volume = 0.25; // Set the default volume to 0.5
            this.sounds[name] = audio;
        } else {
            console.warn(`Sound ${name} already exists.`);
        }
    }

    /**
     * Plays a sound by its name.
     * @param {string} name - The name of the sound to play.
     */
    playSound(name) {
        const sound = this.sounds[name];
        if (sound) {
            sound.currentTime = 0; // Reset the audio to the start
            sound.play().catch(error => {
                console.error(`Error playing sound ${name}:`, error);
            });
        } else {
            console.warn(`Sound ${name} not found.`);
        }
    }

    /**
     * Stops a sound by its name.
     * @param {string} name - The name of the sound to stop.
     * @param {boolean} pause - Whether to pause the sound instead of stopping it.
     */
    stopSound(name, pause = false) {
        const sound = this.sounds[name];
        if (sound) {
            if (pause) {
                sound.pause();
            } else {
                sound.pause();
                sound.currentTime = 0;
            }
        } else {
            console.warn(`Sound ${name} not found.`);
        }
    }

    /**
     * Sets the volume for a specific sound.
     * @param {string} name - The name of the sound.
     * @param {number} volume - The volume level (0.0 to 1.0).
     */
    setVolume(name, volume) {
        const sound = this.sounds[name];
        if (sound) {
            sound.volume = Math.min(Math.max(volume, 0), 1);
        } else {
            console.warn(`Sound ${name} not found.`);
        }
    }
}
// Example usage
const soundManager = new SoundManager();
soundManager.addSound('common', 'assets/media/sounds/btn.wav');
soundManager.addSound('click', 'assets/media/sounds/click.mp3');
soundManager.addSound('hover', 'assets/media/sounds/hover.mp3');
soundManager.addSound('found', 'assets/media/sounds/found.mp3');
soundManager.addSound('match_found', 'assets/media/sounds/match_found.mp3');
soundManager.addSound('letsgo', 'assets/media/sounds/letsgo.wav');



/*export class CustomCarousel {
    constructor(container, options = {}) {
      this.$container = $(container);
      this.id = options.id || `carousel-${Math.random().toString(36).substr(2, 9)}`;
      this.indicators = options.indicators !== undefined ? options.indicators : true;
      this.controls = options.controls !== undefined ? options.controls : true;
      this.eventHandlers = options.eventHandlers || {};
      this.$carousel = null;
      this.$inner = null;
      this.$indicators = null;
  
      this._initCarousel();
    }
  
    _initCarousel() {
      // Crear estructura del carousel
      const carouselHtml = `
        <div id="${this.id}" class="carousel slide" data-bs-ride="carousel">
          ${this.indicators ? '<div class="carousel-indicators"></div>' : ''}
          <div class="carousel-inner"></div>
          ${this.controls ? `
            <button class="carousel-control-prev" type="button" data-bs-target="#${this.id}" data-bs-slide="prev">
              <span class="carousel-control-prev-icon" aria-hidden="true"></span>
              <span class="visually-hidden">Previous</span>
            </button>
            <button class="carousel-control-next" type="button" data-bs-target="#${this.id}" data-bs-slide="next">
              <span class="carousel-control-next-icon" aria-hidden="true"></span>
              <span class="visually-hidden">Next</span>
            </button>` : ''}
        </div>
      `;
      this.$container.html(carouselHtml);
      this.$carousel = this.$container.find('.carousel');
      this.$inner = this.$carousel.find('.carousel-inner');
      this.$indicators = this.$carousel.find('.carousel-indicators');
  
      this._applyEventHandlers();
    }
  
    _applyEventHandlers() {
      const self = this;
      $.each(this.eventHandlers, function(event, handler) {
        self.$carousel.on(event, handler);
      });
    }
  
    updateOptions(newOptions = {}) {
      if (newOptions.indicators !== undefined) {
        this.indicators = newOptions.indicators;
        this._toggleIndicators();
      }
      if (newOptions.controls !== undefined) {
        this.controls = newOptions.controls;
        this._toggleControls();
      }
      if (newOptions.eventHandlers) {
        this.eventHandlers = newOptions.eventHandlers;
        this._applyEventHandlers();
      }
    }
  
    _toggleIndicators() {
      if (this.indicators) {
        if (this.$indicators.length === 0) {
          this.$carousel.prepend('<div class="carousel-indicators"></div>');
          this.$indicators = this.$carousel.find('.carousel-indicators');
          this._rebuildIndicators();
        }
      } else {
        this.$indicators.remove();
        this.$indicators = null;
      }
    }
  
    _toggleControls() {
      if (this.controls) {
        if (this.$carousel.find('.carousel-control-prev').length === 0) {
          this.$carousel.append(`
            <button class="carousel-control-prev" type="button" data-bs-target="#${this.id}" data-bs-slide="prev">
              <span class="carousel-control-prev-icon" aria-hidden="true"></span>
              <span class="visually-hidden">Previous</span>
            </button>
            <button class="carousel-control-next" type="button" data-bs-target="#${this.id}" data-bs-slide="next">
              <span class="carousel-control-next-icon" aria-hidden="true"></span>
              <span class="visually-hidden">Next</span>
            </button>
          `);
        }
      } else {
        this.$carousel.find('.carousel-control-prev, .carousel-control-next').remove();
      }
    }
  
    _rebuildIndicators() {
      this.$indicators.empty();
      const self = this;
      this.$inner.find('.carousel-item').each(function(index) {
        const $indicator = $(`<button type="button" data-bs-target="#${self.id}" data-bs-slide-to="${index}"></button>`);
        if (index === 0) {
          $indicator.addClass('active');
        }
        self.$indicators.append($indicator);
      });
    }
  
    addItem(content, attributes = {}) {
      const itemId = `item-${Math.random().toString(36).substr(2, 9)}`;
      const $item = $(`<div class="carousel-item" id="${itemId}">${content}</div>`);
      $.each(attributes, function (key, value) {
        $item.attr(key, value);
      });
  
      if (this.$inner.find('.carousel-item').length === 0) {
        $item.addClass('active');
      }
  
      this.$inner.append($item);
  
      if (this.indicators) {
        const indicatorIndex = this.$inner.find('.carousel-item').length - 1;
        const $indicator = $(`<button type="button" data-bs-target="#${this.id}" data-bs-slide-to="${indicatorIndex}"></button>`);
        if (indicatorIndex === 0) {
          $indicator.addClass('active');
        }
        this.$indicators.append($indicator);
      }
    }
  
    removeItem(selector) {
        const $items = this.$inner.find(selector);
    
        $items.each((index, item) => {
          const $item = $(item);
          const itemIndex = $item.index();
    
          $item.remove();
    
          if (this.indicators) {
            this.$indicators.find(`button[data-bs-slide-to="${itemIndex}"]`).remove();
          }
        });
    
        this._reindexIndicators();
        this._updateActiveItem();
      }
    
      hideItem(selector) {
        const $items = this.$inner.find(selector);
    
        $items.each((index, item) => {
          const $item = $(item);
          const itemIndex = $item.index();
    
          $item.addClass('d-none');
    
          if (this.indicators) {
            this.$indicators.find(`button[data-bs-slide-to="${itemIndex}"]`).addClass('d-none');
          }
        });
    
        this._reindexIndicators();
        this._updateActiveItem();
      }
    
      showItem(selector) {
        const $items = this.$inner.find(selector);
    
        $items.each((index, item) => {
          const $item = $(item);
          const itemIndex = $item.index();
    
          $item.removeClass('d-none');
    
          if (this.indicators) {
            this.$indicators.find(`button[data-bs-slide-to="${itemIndex}"]`).removeClass('d-none');
          }
        });
    
        this._reindexIndicators();
        this._updateActiveItem();
      }
    
      _reindexIndicators() {
        const self = this;
        this.$inner.find('.carousel-item').each(function (index) {
          self.$indicators.find(`button[data-bs-slide-to="${index}"]`).attr('data-bs-slide-to', index);
        });
      }
    
      _updateActiveItem() {
        if (this.$inner.find('.carousel-item.active').hasClass('d-none')) {
          const $nextVisible = this.$inner.find('.carousel-item:not(.d-none)').first();
          $nextVisible.addClass('active');
        }
      }
  }*/

export class CustomCarousel {
    constructor(container, options = {}) {
        this.$container = $(container);
        this.id = options.id || `carousel-${Math.random().toString(36).substr(2, 9)}`;
        this.indicators = options.indicators !== undefined ? options.indicators : true;
        this.controls = options.controls !== undefined ? options.controls : true;
        this.customIndicatorTemplate = options.customIndicatorTemplate || null;
        this.customControlTemplate = options.customControlTemplate || null; // Nueva opción
        this.carouselOptions = {
            interval: options.interval || 5000,
            ride: options.ride || 'carousel',
            pause: options.pause || 'hover',
            wrap: options.wrap !== undefined ? options.wrap : true,
            keyboard: options.keyboard !== undefined ? options.keyboard : true
        };
        this.eventHandlers = options.eventHandlers || {};
        this.$carousel = null;
        this.$inner = null;
        this.$indicators = null;
        this.carouselInstance = null;

        this._initCarousel();
    }

    _initCarousel() {
        // Crear estructura del carousel
        const carouselHtml = `
            <div id="${this.id}" class="carousel carousel-custom-dark slide carousel-fade" data-bs-ride="${this.carouselOptions.ride}">
                ${this.indicators ? '<ol class="carousel-indicators carousel-indicators-dots"></ol>' : ''}
                <div class="carousel-inner"></div>
                ${this.controls ? this._getControlsHtml() : ''}
            </div>
        `;
        this.$container.html(carouselHtml);
        this.$carousel = this.$container.find('.carousel');
        this.$inner = this.$carousel.find('.carousel-inner');
        this.$indicators = this.$carousel.find('.carousel-indicators');

        this._applyEventHandlers();
        this._initBootstrapCarousel();
    }

    _destroyCarousel() {
        if (this.carouselInstance) {
            this.carouselInstance.dispose();
        }
    }

    _getControlsHtml() {
        if (this.customControlTemplate && typeof this.customControlTemplate === 'function') {
            // Si se proporciona una función para la plantilla personalizada de controles
            return this.customControlTemplate(this.id);
        } else if (typeof this.customControlTemplate === 'string') {
            // Si se proporciona una cadena HTML para la plantilla personalizada de controles
            return this.customControlTemplate;
        } else {
            // Plantilla predeterminada de controles
            return `
                <button class="carousel-control-prev" type="button" data-bs-target="#${this.id}" data-bs-slide="prev">
                    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                    <span class="visually-hidden">Previous</span>
                </button>
                <button class="carousel-control-next" type="button" data-bs-target="#${this.id}" data-bs-slide="next">
                    <span class="carousel-control-next-icon" aria-hidden="true"></span>
                    <span class="visually-hidden">Next</span>
                </button>
            `;
        }
    }

    _applyEventHandlers() {
        const self = this;
        $.each(this.eventHandlers, function(event, handler) {
            self.$carousel.on(event, handler);
        });
    }

    _initBootstrapCarousel() {
        // Destruir instancia anterior si existe
        if (this.carouselInstance) {
            this.carouselInstance.dispose();
        }
        this.carouselInstance = new bootstrap.Carousel(this.$carousel[0], this.carouselOptions);
    }

    updateOptions(newOptions = {}) {
        let needsReinit = false;

        if (newOptions.indicators !== undefined) {
            this.indicators = newOptions.indicators;
            this._toggleIndicators();
        }
        if (newOptions.controls !== undefined) {
            this.controls = newOptions.controls;
            this._toggleControls();
        }
        if (newOptions.customIndicatorTemplate) {
            this.customIndicatorTemplate = newOptions.customIndicatorTemplate;
            this._rebuildIndicators();
        }
        if (newOptions.customControlTemplate) {
            this.customControlTemplate = newOptions.customControlTemplate;
            this._toggleControls(); // Regenerar los controles con la nueva plantilla
        }
        if (newOptions.eventHandlers) {
            this.eventHandlers = newOptions.eventHandlers;
            this._applyEventHandlers();
        }

        // Actualizar opciones del carousel
        const carouselOptionKeys = ['interval', 'ride', 'pause', 'wrap', 'keyboard'];
        carouselOptionKeys.forEach(key => {
            if (newOptions[key] !== undefined) {
                this.carouselOptions[key] = newOptions[key];
                needsReinit = true;
            }
        });

        if (needsReinit) {
            this._initBootstrapCarousel(); // Reinicializar para aplicar nuevas opciones
        }
    }

    _toggleIndicators() {
        if (this.indicators) {
            if (this.$indicators.length === 0) {
                this.$carousel.prepend('<div class="carousel-indicators"></div>');
                this.$indicators = this.$carousel.find('.carousel-indicators');
                this._rebuildIndicators();
            }
        } else {
            this.$indicators.remove();
            this.$indicators = null;
        }
    }

    _toggleControls() {
        if (this.controls) {
            if (this.$carousel.find('.carousel-control-prev').length === 0 && this.$carousel.find('.carousel-control-next').length === 0) {
                const controlsHtml = this._getControlsHtml();
                this.$carousel.append(controlsHtml);
            }
        } else {
            this.$carousel.find('.carousel-control-prev, .carousel-control-next').remove();
        }
    }

    _rebuildIndicators() {
        if (!this.indicators) return;

        this.$indicators.empty();
        const self = this;
        this.$inner.find('.carousel-item').each(function(index) {
            let $indicator;
            if (self.customIndicatorTemplate) {
                if (typeof self.customIndicatorTemplate === 'function') {
                    $indicator = $(self.customIndicatorTemplate(index));
                } else if (typeof self.customIndicatorTemplate === 'string') {
                    $indicator = $(self.customIndicatorTemplate.replace('{{index}}', index).replace('{{id}}', self.id));
                }
            } else {
                $indicator = $(`<button type="button" data-bs-target="#${self.id}" data-bs-slide-to="${index}"></button>`);
            }
            if (index === 0) {
                $indicator.addClass('active');
            }
            self.$indicators.append($indicator);
        });
    }

    addItem(content, attributes = {}) {
        const itemId = `item-${Math.random().toString(36).substr(2, 9)}`;
        const $item = $(`<div class="carousel-item" id="${itemId}">${content}</div>`);
        $.each(attributes, function (key, value) {
            $item.attr(key, value);
        });

        if (this.$inner.find('.carousel-item').length === 0) {
            $item.addClass('active');
        }

        this.$inner.append($item);

        if (this.indicators) {
            const indicatorIndex = this.$inner.find('.carousel-item').length - 1;
            let $indicator;
            if (this.customIndicatorTemplate) {
                if (typeof this.customIndicatorTemplate === 'function') {
                    $indicator = $(this.customIndicatorTemplate(indicatorIndex));
                } else if (typeof this.customIndicatorTemplate === 'string') {
                    $indicator = $(this.customIndicatorTemplate.replace('{{index}}', indicatorIndex).replace('{{id}}', this.id));
                }
            } else {
                $indicator = $(`<button type="button" data-bs-target="#${this.id}" data-bs-slide-to="${indicatorIndex}"></button>`);
            }
            if (indicatorIndex === 0) {
                $indicator.addClass('active');
            }
            this.$indicators.append($indicator);
        }
    }

    removeItem(selector) {
        const $items = this.$inner.find(selector);

        $items.each((index, item) => {
            const $item = $(item);
            const itemIndex = $item.index();

            $item.remove();

            if (this.indicators) {
                this.$indicators.find(`button[data-bs-slide-to="${itemIndex}"]`).remove();
            }
        });

        this._reindexIndicators();
        this._updateActiveItem();
        this._initBootstrapCarousel();
    }

    hideItem(selector) {
        const $items = this.$inner.find(selector);

        $items.each((index, item) => {
            const $item = $(item);
            const itemIndex = $item.index();

            $item.addClass('d-none');

            if (this.indicators) {
                this.$indicators.find(`button[data-bs-slide-to="${itemIndex}"]`).addClass('d-none');
            }
        });

        this._reindexIndicators();
        this._updateActiveItem();
        this._initBootstrapCarousel();
    }

    showItem(selector) {
        const $items = this.$inner.find(selector);

        $items.each((index, item) => {
            const $item = $(item);
            const itemIndex = $item.index();

            $item.removeClass('d-none');

            if (this.indicators) {
                this.$indicators.find(`button[data-bs-slide-to="${itemIndex}"]`).removeClass('d-none');
            }
        });

        this._reindexIndicators();
        this._updateActiveItem();
        this._initBootstrapCarousel();
    }

    _reindexIndicators() {
        const self = this;
        if (this.indicators) {
            let newIndex = 0;
            this.$inner.find('.carousel-item').each(function(index) {
                const $item = $(this);
                if (!$item.hasClass('d-none')) {
                    self.$indicators.find(`button[data-bs-slide-to="${index}"]`).attr('data-bs-slide-to', newIndex);
                    newIndex++;
                }
            });
        }
    }

    _updateActiveItem() {
        const $activeItem = this.$inner.find('.carousel-item.active');
        if ($activeItem.hasClass('d-none')) {
            const $nextVisibleItem = $activeItem.nextAll('.carousel-item:not(.d-none)').first();
            if ($nextVisibleItem.length > 0) {
                $activeItem.removeClass('active');
                $nextVisibleItem.addClass('active');
            } else {
                const $prevVisibleItem = $activeItem.prevAll('.carousel-item:not(.d-none)').first();
                if ($prevVisibleItem.length > 0) {
                    $activeItem.removeClass('active');
                    $prevVisibleItem.addClass('active');
                }
            }
        }
    }

    start() {
        this.carouselInstance.cycle();
    }
    
    stop() {
        this.carouselInstance.pause();
    }
    
    next() {
        this.carouselInstance.next();
    }
    
    prev() {
        this.carouselInstance.prev();
    }
}

      
  
const sanitizeHTML = (html) =>{
    const $temp = $("<div>");
    $temp.html(html);
    const sanitizedHTML = $temp.text();
    return sanitizedHTML;
}

class WindowManager {
    constructor(selector, options = {}) {
        this.elements = $(selector);
        this.settings = $.extend({
            headerSelector: '.custom-window-header', 
            minimizeSelector: '.custom-window-minimize',
            restoreSelector: '.custom-window-restore',
            closeSelector: '.custom-window-close',
            resizable: true,
            draggable: true,
            minWidth: 150,
            maxWidth: 600,
            minHeight: 150,
            maxHeight: 600,
            defaultWidth: 400,  // Ancho predeterminado si no se especifica
            defaultHeight: 300, // Alto predeterminado si no se especifica
            defaultPosition: { bottom: 10, right: 10 }, // Posición predeterminada si no se especifica
            onMinimize: null,
            onRestore: null,
            onClose: null,
            onDrag: null,
            onResize: null,
            onShow: null // Callback al mostrar la ventana
        }, options);

        this.init();
    }

    init() {
        this.elements.each((index, element) => {
            const $element = $(element);

            // Restaurar la posición y el tamaño desde localStorage
            this.restorePositionAndSize($element);

            // Verificar y aplicar estilos por defecto
            this.applyDefaultStyles($element);

            if (this.settings.draggable) {
                this.makeDraggable($element);
            }

            if (this.settings.resizable) {
                this.makeResizable($element);
            }

            this.setupWindowControls($element);
        });
    }

    applyDefaultStyles($element) {
        // Cambiar a position: fixed
        $element.css('position', 'fixed');

        // Verificar y agregar width si no está presente
        if (!$element.width() || $element.width() === 0) {
            $element.css('width', this.settings.defaultWidth + 'px');
        }

        // Verificar y agregar height si no está presente
        if (!$element.height() || $element.height() === 0) {
            $element.css('height', this.settings.defaultHeight + 'px');
        }

        // Asegurarse de que el contenedor tenga `box-sizing: border-box` para mejor control de tamaño
        $element.css('box-sizing', 'border-box');
    }

    makeDraggable($element) {
        let isDragging = false, startX, startY, startLeft, startTop;
    
        $element.on('mousedown', this.settings.headerSelector, (e) => {
            e.preventDefault();
            isDragging = true;
            startX = e.clientX;
            startY = e.clientY;
            startLeft = parseInt($element.css('left'), 10) || 0;
            startTop = parseInt($element.css('top'), 10) || 0;
            $element.addClass('dragging');

            // Desactivar selección de texto
            $('body').css('user-select', 'none');
        });
    
        const onMouseMove = (e) => {
            if (isDragging) {
                const dx = e.clientX - startX;
                const dy = e.clientY - startY;
    
                // Limitar el movimiento al área visible del documento
                const newLeft = Math.max(0, Math.min($(window).width() - $element.outerWidth(), startLeft + dx));
                const newTop = Math.max(0, Math.min($(window).height() - $element.outerHeight(), startTop + dy));
    
                // Actualizar la posición
                $element.css({
                    left: newLeft + 'px',
                    top: newTop + 'px'
                });

                // Guardar la posición en localStorage
                this.savePositionAndSize($element);
    
                if (typeof this.settings.onDrag === 'function') {
                    this.settings.onDrag($element);
                }
            }
        };
    
        const onMouseUp = () => {
            if (isDragging) {
                isDragging = false;
                $element.removeClass('dragging');

                // Restaurar selección de texto
                $('body').css('user-select', '');
            }
        };
    
        $(document).on('mousemove', (e) => requestAnimationFrame(() => onMouseMove(e)));
        $(document).on('mouseup', onMouseUp);
    }

    makeResizable($element) {
        let isResizing = false, startX, startY, startWidth, startHeight, startLeft, startTop, resizingEdge;
        const edges = ['top', 'right', 'bottom', 'left'];
    
        edges.forEach(edge => {
            $element.append(`<div class="resize-handle-${edge} position-absolute"></div>`);
        });

        // Añadir estilos CSS para los handles de redimensionamiento
        $element.find('.resize-handle-top').css({
            top: 0,
            left: 0,
            right: 0,
            height: '5px',
            cursor: 'ns-resize',
            position: 'absolute',
        });
        $element.find('.resize-handle-right').css({
            top: 0,
            right: 0,
            bottom: 0,
            width: '5px',
            cursor: 'ew-resize',
            position: 'absolute',
        });
        $element.find('.resize-handle-bottom').css({
            left: 0,
            right: 0,
            bottom: 0,
            height: '5px',
            cursor: 'ns-resize',
            position: 'absolute',
        });
        $element.find('.resize-handle-left').css({
            top: 0,
            left: 0,
            bottom: 0,
            width: '5px',
            cursor: 'ew-resize',
            position: 'absolute',
        });
    
        $element.on('mousedown', '.resize-handle-top, .resize-handle-right, .resize-handle-bottom, .resize-handle-left', (e) => {
            e.preventDefault();  // Evita la selección de texto
            const handleClass = $(e.target).attr('class');
            resizingEdge = handleClass.includes('top') ? 'top' :
                           handleClass.includes('right') ? 'right' :
                           handleClass.includes('bottom') ? 'bottom' :
                           'left';
    
            isResizing = true;
            startX = e.clientX;
            startY = e.clientY;
            startWidth = $element.width();
            startHeight = $element.height();
            startLeft = parseInt($element.css('left'), 10);
            startTop = parseInt($element.css('top'), 10);
            $element.addClass('resizing');
    
            // Desactivar selección de texto
            $('body').css('user-select', 'none');
        });
    
        $(document).on('mousemove', (e) => {
            if (isResizing) {
                const dx = e.clientX - startX;
                const dy = e.clientY - startY;
                let newWidth = startWidth;
                let newHeight = startHeight;
                let newLeft = startLeft;
                let newTop = startTop;
    
                if (resizingEdge === 'right') {
                    newWidth = Math.max(this.settings.minWidth, Math.min(startWidth + dx, $(window).width() - startLeft));
                } else if (resizingEdge === 'left') {
                    newWidth = Math.max(this.settings.minWidth, Math.min(startWidth - dx, $(window).width() - newLeft));
                    newLeft = startLeft + dx;
                }
    
                if (resizingEdge === 'bottom') {
                    newHeight = Math.max(this.settings.minHeight, Math.min(startHeight + dy, $(window).height() - startTop));
                } else if (resizingEdge === 'top') {
                    newHeight = Math.max(this.settings.minHeight, Math.min(startHeight - dy, $(window).height() - newTop));
                    newTop = startTop + dy;
                }
    
                $element.css({
                    width: newWidth + 'px',
                    height: newHeight + 'px',
                    left: newLeft + 'px',
                    top: newTop + 'px'
                });
    
                this.savePositionAndSize($element);
    
                if (typeof this.settings.onResize === 'function') {
                    this.settings.onResize($element);
                }
            }
        });
    
        $(document).on('mouseup', () => {
            isResizing = false;
            $element.removeClass('resizing');
    
            // Restaurar selección de texto
            $('body').css('user-select', '');
        });
    }

    setupWindowControls($element) {
        const $minimize = $element.find(this.settings.minimizeSelector);
        const $restore = $element.find(this.settings.restoreSelector);
        const $close = $element.find(this.settings.closeSelector);

        if ($minimize.length > 0) {
            $minimize.on('click', () => {
                $element.hide();
                if (typeof this.settings.onMinimize === 'function') {
                    this.settings.onMinimize($element);
                }
            });
        }

        if ($restore.length > 0) {
            $restore.on('click', () => {
                $element.show();
                if (typeof this.settings.onRestore === 'function') {
                    this.settings.onRestore($element);
                }
            });
        }

        if ($close.length > 0) {
            $close.on('click', () => {
                $element.remove();
                if (typeof this.settings.onClose === 'function') {
                    this.settings.onClose($element);
                }
            });
        }
    }

    savePositionAndSize($element) {
        const id = $element.attr('id');
        if (!id) return; // Asegurarse de que el elemento tenga un id
    
        const position = {
            left: parseInt($element.css('left'), 10) || 0,
            top: parseInt($element.css('top'), 10) || 0,
            width: $element.outerWidth() || this.settings.defaultWidth,
            height: $element.outerHeight() || this.settings.defaultHeight
        };

        localStorage.setItem(`window-position-${id}`, JSON.stringify(position));
    }

    restorePositionAndSize($element) {
        const id = $element.attr('id');
        if (!id) return; // Asegurarse de que el elemento tenga un id

        const savedPosition = localStorage.getItem(`window-position-${id}`);
        if (savedPosition) {
            const { left, top, width, height } = JSON.parse(savedPosition);
            $element.css({
                left: left + 'px',
                top: top + 'px',
                width: width + 'px',
                height: height + 'px'
            });
        } else {
            // Si no hay posición guardada, usar la posición y tamaño por defecto
            $element.css({
                right: this.settings.defaultPosition.right + 'px',
                bottom: this.settings.defaultPosition.bottom + 'px',
                width: this.settings.defaultWidth + 'px',
                height: this.settings.defaultHeight + 'px'
            });
        }
    }
}


const animateCSS = (element, animation, prefix = 'animate__', duration = '1s') =>
    // We create a Promise and return it
    new Promise((resolve, reject) => {
        const animationName = `${prefix}${animation}`;
        const node = document.querySelector(element);
    
        node.classList.add(`${prefix}animated`, animationName);
        // Change animation duration
        node.style.setProperty('--animate-duration', duration);
    
        // When the animation ends, we clean the classes and resolve the Promise
        function handleAnimationEnd(event) {
        event.stopPropagation();
        //node.classList.remove(`${prefix}animated`, animationName);
        node.classList.remove(animationName);
        resolve('Animation ended');
        }
    
        node.addEventListener('animationend', handleAnimationEnd, {once: true});
    });

export { _user , _handler , getEloLevel, storage, soundManager, getPingColor, sanitizeHTML, WindowManager, animateCSS };


// Webpack support
if (typeof module !== 'undefined' && typeof module.exports !== 'undefined') {
    module.exports = KTClasses;
}